import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetStaffCostEntriesParams {
  queryType?: string;
  doctorId?: string;
  timeHead?: string;
  timeTail?: string;
}

export function getpeopleSale(params: GetStaffCostEntriesParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/avgRetailAmountList`,
    method: "GET",
    params,
  };
}
